import React, { useEffect } from 'react';

interface Message {
  id: string;
  type: 'success' | 'error';
  message: string;
}

interface MessageSystemProps {
  messages: Message[];
  onRemoveMessage: (id: string) => void;
}

const MessageSystem: React.FC<MessageSystemProps> = ({ messages, onRemoveMessage }) => {
  useEffect(() => {
    // Auto-remove messages after timeout
    messages.forEach(msg => {
      const timeout = msg.type === 'success' ? 3000 : 5000;
      setTimeout(() => {
        onRemoveMessage(msg.id);
      }, timeout);
    });
  }, [messages, onRemoveMessage]);

  return (
    <div className="message-system">
      {messages.map(msg => (
        <div
          key={msg.id}
          className={`message-notification ${msg.type}-message fade-in`}
        >
          <div className="message-content">
            <div className="message-icon">
              {msg.type === 'success' ? '✅' : '❌'}
            </div>
            <p>{msg.message}</p>
          </div>
          <button
            className="message-close"
            onClick={() => onRemoveMessage(msg.id)}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default MessageSystem;

// CSS styles to add to App.css
export const messageSystemStyles = `
.message-system {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1001;
  max-width: 400px;
  pointer-events: none;
}

.message-notification {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  margin-bottom: 0.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
  pointer-events: auto;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.success-message {
  background: #4CAF50;
  color: white;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.error-message {
  background: #f44336;
  color: white;
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.3);
}

.message-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
}

.message-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.message-notification p {
  margin: 0;
  font-weight: 500;
  line-height: 1.4;
}

.message-close {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  margin-left: 1rem;
}

.message-close:hover {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.fade-in {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`; 